import React, { useState, useEffect } from 'react';

const initialState = {
  isMaintenance: true,
  startDate: '',
  endDate: '',
  key: '',
};

export default function MaintenanceConfigPage() {
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  // Load current config for display (read-only fetch)
  useEffect(() => {
    fetch('/maintenanceConfig.json')
      .then((res) => res.json())
      .then((data) => {
        setForm({
          isMaintenance: !!data.isMaintenance,
          startDate: data.startDate || '',
          endDate: data.endDate || '',
          key: '',
        });
      })
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'radio' ? value === 'true' : value,
    }));
  };

  const handleRadio = (e) => {
    setForm((prev) => ({ ...prev, isMaintenance: e.target.value === 'true' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');
    // Placeholder: POST to backend endpoint (not implemented)
    // Replace URL with your backend endpoint
    fetch('/api/update-maintenance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Failed to update');
        return res.json();
      })
      .then(() => {
        setSuccess('Maintenance config updated (simulated).');
      })
      .catch(() => setError('Failed to update (simulated, needs backend).'))
      .finally(() => setLoading(false));
  };

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', padding: 24, border: '1px solid #ccc', borderRadius: 8 }}>
      <h2 style={{ fontWeight: 'bold', color: '#007bff', textAlign: 'center' }}>Maintenance Config</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ marginRight: 16 }}>Is Maintenance:</label>
          <label>
            <input
              type="radio"
              name="isMaintenance"
              value="true"
              checked={form.isMaintenance === true}
              onChange={handleRadio}
            />{' '}
            Yes
          </label>
          <label style={{ marginLeft: 16 }}>
            <input
              type="radio"
              name="isMaintenance"
              value="false"
              checked={form.isMaintenance === false}
              onChange={handleRadio}
            />{' '}
            No
          </label>
        </div>
        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
          <label style={{ minWidth: 90 }}>Start Date:</label>
          <input
            type="datetime-local"
            name="startDate"
            value={form.startDate}
            onChange={handleChange}
            required
            className="form-control"
            style={{ marginLeft: 8, flex: 1 }}
          />
        </div>
        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
          <label style={{ minWidth: 90 }}>End Date:</label>
          <input
            type="datetime-local"
            name="endDate"
            value={form.endDate}
            onChange={handleChange}
            required
            className="form-control"
            style={{ marginLeft: 8, flex: 1 }}
          />
        </div>
        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
          <label style={{ minWidth: 120 }}>Password (Key):</label>
          <input
            type="password"
            name="key"
            value={form.key}
            onChange={handleChange}
            required
            className="form-control"
            style={{ marginLeft: 8, flex: 1 }}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
          <button type="submit" disabled={loading} className="btn btn-success px-4">
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
        {success && <div style={{ color: 'green', marginTop: 16 }}>{success}</div>}
        {error && <div style={{ color: 'red', marginTop: 16 }}>{error}</div>}
      </form>
    </div>
  );
} 